import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'

import { redactTokensRecursive } from '@cash-web/shared/util-redaction'
import { getEnvironmentForBugsnag, isServerEnvironment } from '@cash-web/shared-util-environment'

declare const BUGSNAG_API_KEY: string
declare const BUGSNAG_APP_VERSION: string

let hasInitialized = false
const hasApiKey = () => {
  try {
    return !!BUGSNAG_API_KEY
  } catch (e) {
    return false
  }
}
export const initializeBugsnag = () => {
  // Bugsnag is not currently supported in Cash Cloud
  // or it has been called more than once.
  // or there is no BUGSNAG_API_KEY (which happens in cypress tests)
  if (isServerEnvironment() || hasInitialized || !hasApiKey()) {
    return
  }
  // This is the only place we should be initializing bugsnag
  // eslint-disable-next-line no-restricted-syntax
  Bugsnag.start({
    apiKey: BUGSNAG_API_KEY,
    plugins: [new BugsnagPluginReact()],
    releaseStage: getEnvironmentForBugsnag(),
    enabledReleaseStages: ['production', 'staging', 'unreleased'],
    appVersion: BUGSNAG_APP_VERSION,
    enabledBreadcrumbTypes: ['error', 'log'],
    /*Redact keys directly in redactedKeys.
    More complex redaction should mutate event in onError */
    redactedKeys: [],
    onError: function (event) {
      redactTokensRecursive(event as Partial<Event>)
    },
  })
  hasInitialized = true
}
